import stableStringifyForCacheKey from 'lib/object/stableStringifyForCacheKey'
import { getClosestAirport } from 'selectors/flightsSelectors'

export function getLabGeoAttributes(state: App.State): Record<string, string> | undefined {
  const geoStateName = state.geo.geoStateName?.trim()
  const postcode = state.auth.account?.postcode?.trim()
  const closestAirportCode = getClosestAirport(state)?.code?.trim().toUpperCase()

  const attributes = Object.fromEntries(
    Object.entries({
      geoStateName,
      postcode,
      closestAirportCode,
    }).filter(([_, value]) => value != null && value !== ''),
  )

  return Object.keys(attributes).length > 0 ? attributes as Record<string, string> : undefined
}

export function getLabModalPopupsRequestKey(input: {
  currentPath: string
  distinctId: string
  hasToken: boolean
  featureFlagContext: App.FeatureFlagContext | undefined
  labGeoAttributes: Record<string, string> | undefined
}): string {
  return stableStringifyForCacheKey(input)
}
